import React from 'react';
import { useQuery } from 'react-query';
import {
  Chip,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { teacherModuleAPI } from '../../services/api';
import { dayCheckinStatusColor } from '../../utils/dayCheckinStatus';

export default function TeacherDayCheckinHistory({ month }) {
  const query = useQuery(
    ['teacherDayCheckinMine', month],
    async () => {
      const res = await teacherModuleAPI.getDayCheckinMine(month);
      return res.data?.data;
    },
    { enabled: !!month }
  );

  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        My day start
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Times are in your work-hours timezone. Expected start is the earliest work-hours slot for that day.
      </Typography>
      {query.isLoading ? (
        <CircularProgress size={22} />
      ) : query.isError ? (
        <Typography color="error">
          {query.error?.response?.data?.message || 'Could not load your day start'}
        </Typography>
      ) : (query.data?.days || []).length === 0 ? (
        <Typography color="text.secondary">No work days to show for this month yet.</Typography>
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Expected start</TableCell>
                <TableCell>Marked at</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {query.data.days.map((row) => (
                <TableRow key={row.workDate}>
                  <TableCell>{row.workDateLabel}</TableCell>
                  <TableCell>{row.expectedStartLabel || '—'}</TableCell>
                  <TableCell>{row.markedAtLabel || '—'}</TableCell>
                  <TableCell>
                    <Chip size="small" label={row.statusLabel} color={dayCheckinStatusColor(row.status)} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
}
